const app = {
  state: {
    drawVisible: false,
    curComponent: {
      type: '',
      id: ''
    },
    variableList: {},
    debuggerNodeId: '',
    drawerExtraWidth: 0
  },
  mutations: {
    setCurComponent(state, { type, id }) {
      if (id) {
        state.drawVisible = true;
      } else {
        state.drawVisible = false;
        state.debuggerNodeId = '';
        state.variableList = {};
        state.drawerExtraWidth = 0;
      }
      state.drawVisible = true;
      state.curComponent = {
        type,
        id
      };
    },
    setVaribleList(state, params) {
      console.log(params, 'setVaribleList');
      state.variableList = params;
    },
    setDebuggerNodeId(state, id) {
      state.debuggerNodeId = id;
    },
    setDrawerExtraWidth(state, width) {
      state.drawerExtraWidth = width;
    }
  },
  getters: {
    drawerExtraWidth: state => state.drawerExtraWidth
  }
};
export default app;
